import { render, staticRenderFns } from "./boxCitySelect.vue?vue&type=template&id=350dde7e&scoped=true"
import script from "./boxCitySelect.vue?vue&type=script&lang=js"
export * from "./boxCitySelect.vue?vue&type=script&lang=js"
import style0 from "./boxCitySelect.vue?vue&type=style&index=0&id=350dde7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350dde7e",
  null
  
)

export default component.exports